import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface NotificationItem {
  title?: string;
  body?: string;
  time: Date;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private _subject = new BehaviorSubject<NotificationItem[]>([]);
  public notifications$ = this._subject.asObservable();

  get notifications(): NotificationItem[] {
    return this._subject.value;
  }

  addNotification(item: NotificationItem) {
    const next = [item, ...this._subject.value];
    if (next.length > 50) { next.length = 50; }
    this._subject.next(next);
  }

  clear() {
    this._subject.next([]);
  }

  getCount(): Observable<number> {
    return this.notifications$.pipe(map(arr => arr.length));
  }
}
